/**
 * Servicio para el CRUD de `AuditPlotPlanting` desde el web
 * (Fase C del refactor de doblados). Complementa a
 * `auditPlotService` para permitir al admin/coord editar la
 * estructura de plantings sin depender de la app móvil.
 *
 * Endpoint backend: `/api/audit-plot-plantings/`.
 */

import apiClient from "./apiClient";
import type {
  AuditPlotPlanting,
  AuditPlotPlantingWritePayload,
} from "@/types/audit";

export type { AuditPlotPlantingWritePayload };

const BASE = "/audit-plot-plantings";

export const auditPlotPlantingService = {
  /** Lista los plantings de una parcela auditada.
   *  (El `AuditPlotSerializer` ya los devuelve nested; este endpoint
   *  se usa cuando el editor necesita refrescar tras un guardado.) */
  async list(auditPlotId: string): Promise<AuditPlotPlanting[]> {
    const { data } = await apiClient.get<
      AuditPlotPlanting[] | { results: AuditPlotPlanting[] }
    >(`${BASE}/`, { params: { audit_plot: auditPlotId } });
    // El ViewSet tiene paginación desactivada — pero por seguridad
    // aceptamos ambas formas de respuesta.
    if (Array.isArray(data)) return data;
    return data.results ?? [];
  },

  async create(
    payload: AuditPlotPlantingWritePayload,
  ): Promise<AuditPlotPlanting> {
    const { data } = await apiClient.post<AuditPlotPlanting>(
      `${BASE}/`,
      payload,
    );
    return data;
  },

  async update(
    id: string,
    payload: Partial<AuditPlotPlantingWritePayload>,
  ): Promise<AuditPlotPlanting> {
    const { data } = await apiClient.patch<AuditPlotPlanting>(
      `${BASE}/${id}/`,
      payload,
    );
    return data;
  },

  async remove(id: string): Promise<void> {
    await apiClient.delete(`${BASE}/${id}/`);
  },
};
